import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AbstractModalComponent } from "../abstract-modal/abstract-modal.component";
import { BsModalRef } from "ngx-bootstrap/modal";
import { WarningModalService } from "../../services/warning-modal/warning-modal.service";
import { ConstantsService } from "../../services/constants/constants.service";
import { PermissionsService } from 'src/app/services/permissions/permissions.service';

@Component({
  selector: 'app-questionnaire-limit-modal',
  templateUrl: './questionnaire-limit-modal.component.pug',
  styleUrls: ['./questionnaire-limit-modal.component.scss'],
  standalone: false
})
export class QuestionnaireLimitModalComponent extends AbstractModalComponent implements OnInit {

  @Input() questionnaire_limit!: any;
  @Input() model!: string;
  @ViewChild('orgForm', { static: false }) orgForm: any;
  orgDetails: any;
  showValidationError = false;
  QUESTIONNAIRE_LIMIT = ConstantsService.QUESTIONNAIRE_LIMIT;
  PULSE_QUESTIONNAIRE_LIMIT: number[] = [];

  constructor(public _bsModalRef: BsModalRef, public modal: WarningModalService, public permissions: PermissionsService) {
    super(_bsModalRef, modal);
  }

  ngOnInit(): void {
    this.orgDetails = this.model == 'exit' ? { 'questionnaire_limit': this.questionnaire_limit } : { 'pulse_questionnaire_limit': this.questionnaire_limit }

    if (this.permissions.isFeatureActivated('ENT-10363-pulse-relaunch')) {
      this.PULSE_QUESTIONNAIRE_LIMIT = ConstantsService.PULSE_QUESTIONNAIRE_LIMIT;
    } else {
      this.PULSE_QUESTIONNAIRE_LIMIT = ConstantsService.DEPRECATED_PULSE_QUESTIONNAIRE_LIMIT;
    }
  }

  cancel() {
    this.canDeactivate().subscribe(response => {
      if (response) {
        this.markAsPristine();
        this._bsModalRef.hide();
      }
    });
  }

  save() {
    this.messages = [];
    this.showValidationError = true;
    if (!this.orgForm.valid) {
      return;
    }
    this.event.emit(this.orgDetails);
  }

  getForm() {
    return this.orgForm;
  }

}
